import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  username: string;
  name: string;
  email: string;
  role: "consumer" | "provider" | "admin";
  service_name: string | null;
  category: string | null;
  plan: "free" | "light";
  avatar_url: string | null;
  bio: string | null;
  slogan: string | null;
  location: string | null;
  philosophy: string | null;
  skills: string[] | null;
  cover_image_url: string | null;
  follower_count: number;
  review_count: number;
  rating: number;
  extra_video_slots: number;
  faq: { question: string; answer: string }[] | null;
  company_overview: string | null;
  employee_count: string | null;
  capital_amount: string | null;
  service_content: string | null;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  subscription_status: string | null;
  created_at: string;
  updated_at: string | null;
};

export type Product = {
  id: string;
  provider_id: string;
  title: string;
  type: "video" | "kit";
  price: number;
  description: string | null;
  thumbnail_url: string | null;
  category: string | null;
  status: "public" | "draft" | "hidden";
  total_minutes: number | null;
  sales_count: number;
  stock_count: number;
  difficulty: string | null;
  target_audience: string | null;
  is_free_sample: boolean;
  curriculum: string | null;
  kit_contents: string | null;
  shipping_note: string | null;
  visibility: "public" | "draft";
  purchase_price: number;
  created_at: string;
  updated_at: string | null;
  provider?: Profile;
};

export type Purchase = {
  id: string;
  buyer_id: string;
  provider_id: string;
  product_type: "video" | "kit";
  product_id: string;
  product_title: string;
  price: number;
  status: "completed" | "refunded" | "pending";
  purchased_at: string;
  provider?: Profile;
};

export type Conversation = {
  id: string;
  consumer_id: string;
  provider_id: string;
  purchased_item_title: string | null;
  last_message: string | null;
  last_message_at: string | null;
  consumer_unread: number;
  provider_unread: number;
  created_at: string;
  consumer?: Profile;
  provider?: Profile;
};

export type Message = {
  id: string;
  conversation_id: string;
  sender_id: string;
  content: string;
  is_read: boolean;
  created_at: string;
  sender?: Profile;
};

export type Review = {
  id: string;
  reviewer_id: string;
  provider_id: string;
  product_id: string | null;
  purchase_id: string | null;
  rating: number;
  content: string | null;
  reviewer_role: string | null;
  product_title: string | null;
  is_hidden: boolean;
  created_at: string;
  reviewer?: Profile;
};
